import React from 'react';
import { ReactComponent as Avatar } from '../../images/avatarDefault.svg';
import { AiOutlineCheck } from 'react-icons/ai';
import './agentselection.scss';

export default function AgentSelection({ name, selected, onToggle, assigned }) {
  return (
    <div
      className="agentselection"
      style={{ backgroundColor: assigned ? '#b5b5b5' : '' }}
    >
      <Avatar className="agentselection__avatar" />
      <p>{name}</p>
      <div className="agentselection__checker" onClick={onToggle}>
        {selected && <AiOutlineCheck color="var(--primary-color)" />}
      </div>
    </div>
  );
}
